import { useTranslation } from 'react-i18next';

export default function ComparisonTable() {
  const { t } = useTranslation();

  const features = [
    { name: t('compare.f1'), free: t('compare.v1.free') },
    { name: t('compare.f2'), free: t('compare.v2.free') },
    { name: t('compare.f3'), free: t('compare.v3.free') },
    { name: t('compare.f4'), free: t('compare.v4.free') },
    { name: t('compare.f5'), free: t('compare.v5.free') },
    { name: t('compare.f6'), free: t('compare.v6.free') },
    { name: t('compare.f7'), free: t('compare.v7.free') },
    { name: t('compare.f9'), free: t('compare.v9.free') },
    { name: t('compare.f10'), free: t('compare.v10.free') },
  ];

  return (
    <section className="py-20 lg:py-32 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-4">
            {t('compare.title')}
          </h2>
          <p className="text-lg lg:text-xl text-gray-600 font-semibold">
            {t('compare.subtitle')}
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-primary to-primary-600">
                  <th className="px-6 py-5 text-left text-base font-black text-white">
                    {t('compare.feature')}
                  </th>
                  <th className="px-6 py-5 text-center text-base font-black text-white">
                    {t('compare.free')}
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {features.map((feature, index) => (
                  <tr key={index} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-5 text-base font-semibold text-gray-900">
                      {feature.name}
                    </td>
                    <td className="px-6 py-5 text-center">
                      <span className="inline-flex items-center justify-center text-base font-bold text-primary">
                        {feature.free === 'Yes' || feature.free === '是' ? (
                          <i className="ri-check-line text-2xl"></i>
                        ) : feature.free === 'No' || feature.free === '否' ? (
                          <i className="ri-close-line text-2xl text-gray-400"></i>
                        ) : (
                          feature.free
                        )}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-base font-semibold text-gray-600 mb-6">
            所有功能完全免费，无需付费升级
          </p>
          <a
            href="/generator"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-white rounded-full font-bold text-lg hover:bg-primary-600 transition-all hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            立即开始免费使用
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}